import styled from "styled-components";

export const ControllerWrapper = styled.div`
  background: #0e0d2b;
  width: 100%;
  height: auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: 46px 30px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TimerControllerHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const TimerControllerContentWrapper = styled.div`
  display: flex;
  gap: 26px;
  flex: 1;
`;

export const TimerControllerBackgroundBox = styled.div<{
  width?: string;
  flex?: number;
  height?: string;
}>`
  background: #2e2e2e;
  backdrop-filter: blur(10px);
  border-radius: 20px;
  max-width: ${(p) => (p.width ? p.width : "100%")};
  height: auto;
  max-height: ${(p) => (p.height ? p.height : "100%")};
  padding: 40px 30px 20px;
  box-sizing: border-box;
  flex: ${(p) => (p.flex ? p.flex : 1)};

  > .title {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 30px;
    color: #ffffff;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
  }

  > .box {
    margin-top: 20px;
    width: 100%;
    height: 64px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 20px;
    line-height: 64px;
    color: #121212;
    text-align: center;
    background: #fff;
  }
`;

export const TimerControllerInputBox = styled.div<{
  width?: string;
  height?: string;
  font?: string;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  height: ${(p) => (p.height ? p.height : "100%")};
  box-sizing: border-box;
  flex: 1;
  min-width: 70px;

  > input {
    min-width: ${(p) => (p.width ? p.width : "100%")};
    width: 100%;
    height: ${(p) => (p.height ? p.height : "100%")};
    border: none;
    outline: none;
    font-family: Pretendard;
    font-weight: 600;
    font-size: ${(p) => (p.font ? p.font : "20px")};
    text-align: center;
    border-radius: 20px;
  }

  > textarea {
    min-width: ${(p) => (p.width ? p.width : "100%")};
    width: 100%;
    height: ${(p) => (p.height ? p.height : "100%")};
    border: none;
    outline: none;
    font-family: Pretendard;
    font-weight: 600;
    font-size: ${(p) => (p.font ? p.font : "20px")};
    border-radius: 20px;
    padding: 20px;
    box-sizing: border-box;
    resize: none;
    scrollbar-width: none;
  }
`;

export const TimerControllerBox = styled.div<{
  width?: string;
  height?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  border-radius: 20px;
  background-image:
    linear-gradient(#424242ff, #424242ff),
    linear-gradient(180deg, #fff 0%, #0000003a 80%);
  background-origin: border-box;
  background-clip: content-box, border-box;
  width: ${(p) => (p.width ? p.width : "100%")};
  height: ${(p) => (p.height ? p.height : "100%")};
  box-sizing: border-box;

  font-family: Pretendard;
  font-weight: 600;
  font-size: 20px;
  color: #fff;
`;

export const TimerControllerHeaderTabs = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  flex: 1;
  max-height: max-content;

  > .button {
    width: 130px;
    height: 57px;
    border-radius: 20px;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 25px;
    line-height: 57px;
    text-align: center;
    color: #969696;
    cursor: pointer;

    &.select {
      background: #6436e7;
      color: #fff;
    }
  }
`;

export const TimerControllerPopupInputWrapper = styled.div<{
  width?: string;
  height?: string;
  disabled?: boolean;
}>`
  width: ${(p) => (p.width ? p.width : "100%")};
  height: ${(p) => (p.height ? p.height : "45px")};
  box-sizing: border-box;
  border: 1px solid #e5e5e5;
  border-radius: 15px;
  padding: 0 15px;

  > input {
    outline: none;
    width: 100%;
    height: 100%;
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    background: transparent;
    border: none;
    color: #121212;
  }

  ${({ disabled }) =>
    disabled &&
    `
      border: 1px solid #e5e5e5;
      opacity: var(--opacity-100, 1);
      background: #e5e5e5;
    `}

  > input::placeholder {
    color: var(--Black-200, #b7b7b7);
  }
`;

export const TimerControllerDropBox = styled.div<{
  top?: string;
  left?: string;
  width?: string;
}>`
  position: absolute;
  top: ${(p) => (p.top ? p.top : "0")};
  left: ${(p) => (p.left ? p.left : "0")};
  border-radius: 8px;
  padding: 12px;
  gap: 4px;
  box-shadow: 0px 0px 8px 0px #0000001f;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  z-index: 100;
  box-sizing: border-box;
  width: ${(p) => (p.width ? p.width : "auto")};

  > .item {
    box-sizing: border-box;
    background: #ffffff;
    width: ${(p) => (p.width ? p.width : "90px")};
    height: 30px;
    border-radius: 15px;
    padding: 0 12px;
    border: 1px solid var(--Black-100, #f0f0f0);
    font-family: Pretendard;
    font-weight: 600;
    font-size: 12px;
    line-height: 30px;
    color: var(--Black-500, #202020);
    text-align: center;
    cursor: pointer;

    &.selected {
      background: #7f25fb;
      color: #fff;
    }
  }
`;

export const TimerControllerDropBoxItem = styled.div``;
